/**
 * Product Category Endpoints
 */

export const apiPostProductCategory = async (
  category: ProductCategoryCreateUpdate,
): Promise<AxiosResponse<ProductCategory>> => {
  return await userManagementAxiosInstance.post('categories', category);
};

export const apiGetProductCategories = async (
  limit: number = defaultLimit,
  offset: number = defaultOffset,
): Promise<AxiosResponse<PaginatedProductCategory>> => {
  return await userManagementAxiosInstance.get(`categories?limit=${limit}&offset=${offset}`);
};

export const apiGetProductCategory = async (
  id: string | number,
): Promise<AxiosResponse<ProductCategory>> => {
  return await userManagementAxiosInstance.get(`categories/id/${id}`);
};

export const apiPutProductCategory = async (
  category: ProductCategoryCreateUpdate,
): Promise<AxiosResponse<ProductCategory>> => {
  return await userManagementAxiosInstance.put(`categories/id/${category.id}`, category);
};

export const apiDeleteProductCategory = async (
  id: string | number,
): Promise<AxiosResponse<ProductCategory>> => {
  return await userManagementAxiosInstance.delete(`categories/id/${id}`);
};
